import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccentureLogoSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	baseProfile: "tiny-ps",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1649 1740",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Accenture-svg" }),
		/* @__PURE__ */ _jsx("style", { children: "\n		tspan { white-space:pre }\n		.shp0 { fill: #a100ff } \n	" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Layer",
				className: "shp0",
				d: "M0.25 1228L962.68 869.83L0.25 501.43L0.25 0L1648.67 665.17L1648.67 1074.5L0.25 1739.66L0.25 1228Z"
			})
		})
	]
});
export default SvgAccentureLogoSmall;
